// runtime mapping for string[] -> color
// Generic color assigner factory. Use this to create string -> color mappers for any string[] + palette.
export const createColorAssignerFactory = (palette: string[], defaultColor: string) => {
  let map: Record<string, string> = {};

  const assign = (types: string[]) => {
    const m: Record<string, string> = {};
    for (let i = 0; i < types.length; i++) {
      const t = types[i];
      m[t] = palette[i % palette.length];
    }
    map = m;
  };

  const getColorFor = (type: string | null | undefined) => {
    if (!type) return defaultColor;

    const result = map[type];
    if (result) return result;

    return defaultColor;
  };

  return { assign, getColorFor };
};